import { graphql } from "babel-plugin-relay/macro";
import React from "react";
import { createFragmentContainer } from "react-relay";
import { FilesElement_element$data } from "../../__generated__/FilesElement_element.graphql";
import { FilesElement_screener$data } from "../../__generated__/FilesElement_screener.graphql";
import { CommonElementProps } from "./Element";
import { ElementBase } from "./index";

type Props = {
  element: FilesElement_element$data;
  screener: FilesElement_screener$data;
} & CommonElementProps;
const FilesElement: React.FC<Props> = props => <ElementBase {...props} />;

export default createFragmentContainer(FilesElement, {
  element: graphql`
    fragment FilesElement_element on ElementNode {
      ...ElementBase_element
    }
  `,
  screener: graphql`
    fragment FilesElement_screener on ScreenerNode {
      ...ElementBase_screener
    }
  `,
});
